import classNames from "classnames";
import map from "lodash/map";
import React from "react";
import Styled from "./navigationPath.styled";
export default function NavigationPath(props) {
    var _a;
    const pathLength = ((_a = props.path) === null || _a === void 0 ? void 0 : _a.length) || 0;
    return (React.createElement(Styled.PathContainer, { height: props.height, className: props.className }, map(props.path, (e, ind) => [
        e.href ? (React.createElement("a", { key: e.href, href: e.href, className: classNames(ind !== pathLength - 1 ? "text-light-on-surface-variant" : "text-light-on-surface", "underline-text-on-hover") }, e.title)) : (React.createElement("span", { key: e.title, className: ind !== pathLength - 1 ? "text-light-on-surface-variant" : "text-light-on-surface" }, e.title)),
        ind !== pathLength - 1 && (React.createElement("span", { className: "p-0_5 text-light-on-surface-variant", key: `${e.href}_delimiter` }, "/"))
    ])));
}
NavigationPath.defaultProps = {
    path: [],
    height: "auto"
};
